import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth.jsx";
import { formatApiError } from "@/lib/api";
import { ShieldCheck, ArrowLeft } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center px-6"
      style={{ background: "var(--vp-bg)" }}
    >
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-[var(--vp-muted)] mb-6 hover:text-[var(--vp-text)]">
          <ArrowLeft size={14} /> Nazaj na stran
        </Link>
        <div className="rounded-2xl border border-[var(--vp-border)] bg-white p-8 shadow-sm">
          <div className="flex items-center gap-3 mb-6">
            <span
              className="inline-flex h-10 w-10 items-center justify-center rounded-xl text-white"
              style={{ background: "var(--vp-primary)" }}
            >
              <ShieldCheck size={20} />
            </span>
            <div>
              <h1 className="font-display font-bold text-xl">Admin prijava</h1>
              <p className="text-sm text-[var(--vp-muted)]">Pregled prejetih primerov</p>
            </div>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-sm font-semibold">E-naslov</Label>
              <Input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1.5"
              />
            </div>
            <div>
              <Label className="text-sm font-semibold">Geslo</Label>
              <Input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1.5"
              />
            </div>
            {error && (
              <div data-testid="login-error" className="text-sm text-red-600 bg-red-50 rounded-lg px-3 py-2">
                {error}
              </div>
            )}
            <Button
              type="submit"
              data-testid="login-submit"
              disabled={loading}
              className="w-full rounded-full py-6 font-semibold"
              style={{ background: "var(--vp-primary)", color: "white" }}
            >
              {loading ? "Prijavljanje…" : "Prijavi se"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
